import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';
import Header from '../components/header';

function BrainInjuryView() {
  useDocumentTitle('Brain injury-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-17'}
        title={'Brain Injury'}
        link={'brain-injury'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Support through your rehabilitation and with your ongoing needs
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  A brain injury can leave you with multiple physical,
                  emotional, behavioral, and cognitive needs.
                </p>
                <p className="values_p3">
                  A brain injury can take many forms. It has many causes and
                  levels of severity. We provide care and support to patients
                  with brain injuries, such as:
                </p>

                <div>
                  <ul className="care_bullets2">
                    <li>Traumatic brain injuries (TBI)</li>
                    <li>Encephalitis</li>
                    <li>Tumours</li>
                    <li>Hydrocephalus</li>
                    <li>Hemorrhage</li>
                    <li>Hypoxia/Anoxia</li>
                    <li>Stroke</li>
                  </ul>
                </div>
                <p>
                  We are aware that everyone affected by a brain injury may find
                  it extremely difficult to manage its consequences. We listen
                  in order to completely comprehend your specific needs.
                </p>
                <p>
                  {' '}
                  Our care packages are intended to help you maintain as much
                  independence as possible while providing more complex
                  interventions and full-time support as needed. A small care
                  team will be in place to assist you with your daily chores.
                  Whatever your needs, we can make it easier for you to live
                  comfortably at home.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke care package
                </h2>
                <p className="white-color">
                  If necessary, we will collaborate with you, your family, and
                  multidisciplinary teams to design a customized package of care
                  that will address your clinical, social, and personal needs.
                </p>
                <p className="white-color">
                  At the beginning of your journey, we frequently collaborate
                  closely with acute settings and brain rehabilitation units to
                  ease your transition home.
                </p>
                <p className="white-color">
                  Along with the practical and clinical aspects of your care, we
                  take into account the social and emotional aspects of your
                  everyday life.
                </p>
                <p className="white-color">
                  We have a wealth of expertise providing care for people with
                  brain injuries, which has prepared us to assist our clients
                  and their families during a period that can be incredibly
                  difficult.
                </p>
                <h2 className="white-color">The way we support you</h2>
                <p className="white-color">
                  {' '}
                  The type of care we provide for you at home includes:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Support with your initial discharge from a rehabilitation
                      or hospital unit.
                    </li>
                    <li className="">
                      Setting goals relevant to your rehabilitation as we work
                      with other professionals,
                    </li>
                    <li>
                      Helping you develop confidence towards greater
                      independence and involvement within the local community.
                    </li>
                    <li>
                      Supporting your ongoing daily living such as shopping,
                      attending social activities, visiting friends, and general
                      errands.
                    </li>
                    <li>Accompanying you to school, college, or work.</li>
                    <li>Assisting you with any health needs if required.</li>
                    <li>
                      Providing respite and additional support to your family.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Living with a brain injury</h2>
                <p className="">
                  An acquired brain injury may have long-lasting or even
                  permanent consequences. While recovery and rehabilitation are
                  possible for those who have suffered serious brain injuries,
                  they frequently must completely adapt their lives due to the
                  fact that, unlike most other injuries, a brain injury does not
                  simply heal over time.
                </p>
                <p>
                  A crucial component of rehabilitation and ongoing treatment is
                  assisting our patients and their families in adjusting to the
                  long-term effects of a brain injury.
                </p>
                <p>
                  A brain injury can impact how someone thinks, learns, and
                  recalls things. There may be long-term effects on thought,
                  memory, comprehension, focus, problem-solving, and language
                  use depending on where the injury occurred.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">What a brain injury is</h2>
                <p className="white-color">
                  A brain injury happens when there is severe brain damage due
                  to head trauma or a blow. There are numerous causes of brain
                  injuries, and they can vary in severity from "mild," which
                  involves a brief change in mental status, to "severe," which
                  involves an extended period of unconsciousness that results in
                  long-term issues.
                </p>
                <h2 className="white-color">Types of brain injuries</h2>
                <p className="white-color">
                  Traumatic brain injury (TBI) is damage to the brain brought on
                  by an abrupt, and severe head trauma or head injury. TBI can
                  happen when the head hits something abruptly and violently or
                  when something pierces the skull and enters the brain.
                  Depending on how much brain damage has occurred, TBI symptoms
                  can range from mild to severe.
                </p>
                <p className="white-color">
                  Acquired brain injury (ABI) or non-traumatic injury is a term
                  that refers to all types of brain injuries that are
                  hereditary, congenital, degenerative, or induced by birth
                  trauma.. It can cause damage to the brain by internal factors
                  including;
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>Stroke</li>
                    <li>Aneurysm,</li>
                    <li>Tumor</li>
                    <li>
                      An infectious disease that affects the brain (for example
                      meningitis),
                    </li>
                    <li>
                      Lack of oxygen supply to the brain (for example a heart
                      attack).
                    </li>
                  </ul>
                </div>
                <p className="white-color">
                  Factors such as the type of injury, its location, and its
                  severity will influence the effects that the traumatic brain
                  injury has on a patient, Symptoms can range, from physical
                  effects such as balance problems, headaches, and dizziness to
                  cognitive, emotional, and behavioral changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our clients have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default BrainInjuryView;
